import { ComponentProps, ReactElement, useCallback, useState } from 'react';
import { Platform, TouchableOpacity } from 'react-native';
import { IconProps } from '@ui-kitten/components';

import { Input } from '@pletly/ui';
import { Lock } from '../icons/Lock';
import { Eye } from '../icons/Eye';
import i18n from '../../i18n';

export const Password = ({ placeholder, ...inputProps }: Props) => {
	const { t } = i18n;
	const [passwordVisible, setPasswordVisible] = useState(false);

	const renderPasswordIcon = (props: IconProps): ReactElement => (
		<TouchableOpacity onPress={onPasswordIconPress}>
			<Eye {...props} active={passwordVisible} />
		</TouchableOpacity>
	);

	const onPasswordIconPress = useCallback(() => {
		setPasswordVisible((passwordVisible) => !passwordVisible);
	}, []);

	const label = placeholder || t('common.password');

	return (
		<Input
			textContentType="password"
			placeholder={label}
			accessoryRight={renderPasswordIcon}
			secureTextEntry={!passwordVisible}
			{...(Platform.OS === 'web' ? { label } : { accessoryLeft: Lock })}
			{...inputProps}
		/>
	);
};

type Props = ComponentProps<typeof Input>;
